<template>
  <div class="control__elements">
    <div class="field-barcode">
      <BarcodeCanvas
        :value="resolvedSourceValue"
        :format="field.barcode_format"
        :height="60"
      />
      <p v-if="sourceFieldName" class="field-barcode__source-note">
        {{ $t('rowEditFieldBarcode.sourceNote', { name: sourceFieldName }) }}
      </p>
    </div>
  </div>
</template>

<script>
import rowEditField from '@baserow/modules/database/mixins/rowEditField'
import sourceFieldReferenceField from '@baserow/modules/database/mixins/sourceFieldReferenceField'
import BarcodeCanvas from '@baserow/modules/database/components/field/BarcodeCanvas'

export default {
  name: 'RowEditFieldBarcode',
  components: { BarcodeCanvas },
  mixins: [rowEditField, sourceFieldReferenceField],
  computed: {
    sourceFieldName() {
      const fields =
        this.allFieldsInTable?.length > 0
          ? this.allFieldsInTable
          : this.$store.getters['field/getAll']
      return fields.find((f) => f.id === this.field.source_field_id)?.name
    },
  },
}
</script>
